import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Globals } from "../../_models/globals";
import { ApiIntegration } from "../../_services/api.integration";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
import { User } from '../../_models/user';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-flipkart-auth',
  templateUrl: './flipkart-auth.component.html',
  styleUrls: ['./flipkart-auth.component.scss'],
})
export class FlipkartAuthComponent implements OnInit {
  code: string = '';
  state: string = '';
  constructor(private alertService: AlertService, private g: Globals, public user: User, private api: ApiIntegration, private http: HttpClient, private route: ActivatedRoute, private router: Router) {
    this.route.queryParams
      .subscribe((params: any) => {
        if ((params || {}).code) {
          this.code = params.code;
        }
        if ((params || {}).state) {
          this.state = params.state;
        }
      });
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/toGetFlipkartOauthToken', {
      "accountOwnerId": this.state,
      "oAuthcode": this.code,
      "connectionName": "FLIPKART",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Flipkart', data['message']);
          if (data['storeId']) {
            this.router.navigate(['/admin/flipkartManageStoreManagement', { type: 'FLIPKART', id: data['storeId'] }]);
          }
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
    console.log(this.code);
  }

  ngOnInit() { }

}
